import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';

const HCAPTCHA_SITEKEY = process.env.REACT_APP_HCAPTCHA_SITEKEY || '';

export const CaptchaField = forwardRef(({ onVerify, onExpire }, ref) => {
  const captchaRef = useRef(null);

  useImperativeHandle(ref, () => ({
    resetCaptcha: () => captchaRef.current?.resetCaptcha(),
  }));

  if (!HCAPTCHA_SITEKEY) return null;

  return (
    <div className="flex justify-center my-4">
      <HCaptcha
        ref={captchaRef}
        sitekey={HCAPTCHA_SITEKEY}
        onVerify={onVerify}
        onExpire={() => {
          onVerify(null);
          if (onExpire) onExpire();
        }}
        onError={() => onVerify(null)}
      />
    </div>
  );
});

CaptchaField.displayName = 'CaptchaField';
